export const getOutlineButton = (theme)=>({
        base: {
            color: theme.button.outline.label,
            backgroundColor: 'transparent',
            border: '1px solid',
            borderColor: theme.button.outline.default,
            boxShadow: 'none',
            '&:hover': {
                borderColor: theme.button.outline.hover
            },
            '&:active, &:focus:not(:focus-visible)': {
                borderColor: theme.button.outline.pressed,
                outline: 'none'
            },
            '&:focus': {
                outline: `2.5px solid ${theme.button.focused.default}`,
                outlineOffset: 4,
                borderColor: theme.button.outline.pressed,
                background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
                backgroundBlendMode: 'lighten'
            }
        },
        active: {},
        isLoading: {},
        disabled: {
            backgroundColor: 'transparent',
            borderColor: theme.border.interactive.disabled,
            color: theme.button.disabled.label,
            cursor: 'not-allowed',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'none'
            },
            '&:active, &:focus:not(:focus-visible)': {
                backgroundColor: 'none',
                outline: 'none',
                boxShadow: 'none'
            },
            svg: {
                color: theme.button.ghost.disabled
            }
        }
    });

//# sourceMappingURL=outline.js.map